export default __webpack_public_path__ + "static/media/RajendarUncleji.5c5798f2.jpeg";